export const meKeys = {
  all: ["me"] as const,
  detail: () => [...meKeys.all, "detail"] as const,
  acceptInviteContext: (organizationId: string) =>
    [...meKeys.all, "acceptInviteContext", organizationId] as const,
};
